import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import Introduction from "./Introduction";
import VideoGuides from "./VideoGuides";
import YourCommitmentToConfidentiality from "./Commitment";
import Subsection1 from "./Subsection1";
import Subsection2 from "./Subsection2";
import Subsection3 from "./Subsection3";
import Subsection4 from "./Subsection4";
import Subsection5 from "./Subsection5";
import GrantsFromExternalSources from "./Subsection6";
import AcademicAnalytics from "./Subsection7";
import MissingData from "./Subsection8";
import ResponseRates from "./Subsection9";
import Subsection6oldTable from "./Subsection10";
import BreadcrumbNav from "../../navigation/Breadcrumb";
import BottomNavigation from "../../navigation/BottomNavigation";

interface AppendixProps {
  toggleSection: (section: string, open?: boolean) => void;
}

const Appendix: FC<AppendixProps> = ({ toggleSection }) => {
  const { subsection } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [subsection]);

  useEffect(() => {
    toggleSection("Appendix", true);
  }, [toggleSection])

  return (
    <>
      <BreadcrumbNav section="appendix" subsection={subsection} />

      <h1>Appendix</h1>
      {subsection === "brief-summary" && <Introduction />}
      {subsection === "video-guides" && <VideoGuides />}
      {subsection === "your-commitment-to-confidentiality" && <YourCommitmentToConfidentiality />}
      {subsection === "eligible-population" && <Subsection1 />}
      {subsection === "administration" && <Subsection2 />}
      {subsection === "reporting-analysis" && <Subsection3 />}
      {subsection === "references" && <Subsection4 />}
      {subsection === "how-to-contact-coache" && <Subsection5 />}
      {subsection === "the-analytic-sample-grants-from-external-sources" && <GrantsFromExternalSources />}
      {subsection === "the-analytic-sample-academic-analytics" && <AcademicAnalytics />}
      {subsection === "the-analytic-sample-missing-data" && <MissingData />}
      {subsection === "the-analytic-sample-response-rates" && <ResponseRates />}
      {subsection === "the-negotiation-terms-rank-tenure-title" && <Subsection6oldTable />}

      <BottomNavigation />
    </>
  )
}

export default Appendix;